import type { VerticalCardData } from '@/app/components/shared/cards/VerticalCard'
import { resolveEventPrice } from '@/app/lib/pricing'
import { resolvePurchaseState } from '@/app/lib/purchaseState'

import type { SearchProduct } from './types'

/**
 * `SearchProduct` ("Productos más buscados" del buscador) → `VerticalCardData`,
 * para pintarlos con la misma `VerticalCard` que el grid de `/search`.
 *
 * `module_search.products_most_searched` solo trae título, imagen, precio
 * "desde" y recinto: no hay fechas, promociones ni estado de compra, así que
 * `date` va vacío (la card lo omite), el precio no lleva descuento y el CTA
 * es el estado de compra por defecto. `url` ya llega resuelta (categoría +
 * slug) por `mapSearchProduct`.
 */
export function mapSearchProductToCard(product: SearchProduct): VerticalCardData {
  const priceDisplay = resolveEventPrice({
    minPrice: product.min_price ?? product.price,
    originalPrice: null,
    visiblePromotions: [],
    hasAppPromotions: false,
  })
  const purchaseState = resolvePurchaseState({
    isCancelled: false,
    purchaseText: null,
    disablePurchase: false,
    soldOut: false,
    saleEnd: null,
    saleStart: null,
  })

  return {
    productId: product.id,
    title: product.title,
    href: product.url,
    img: product.image,
    date: '',
    venue: product.venue?.city ?? product.province,
    priceDisplay,
    ctaLabel: purchaseState.ctaLabel,
    imageBadge: purchaseState.imageBadge ?? undefined,
    ctaDisabled: !purchaseState.ctaEnabled,
  }
}
